import { useMutation } from '@apollo/client';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { CREATE_PARTNER_FORM } from '~src/apollo/mutations/form';

import { Input, Textarea } from './input';
import {
  Box,
  Container,
  FormWrapper,
  InputBox,
  Submit,
  TextareaBox,
} from './styles';

type FormData = {
  firstName: string;
  lastName: string;
  company: string;
  companyEmail: string;
  phone: string;
  message: string;
};

const copy = {
  firstName: {
    label: `Ime *`,
    error: {
      validate: `Ime nije validno!`,
      required: `Ime je neophodno!`,
    },
  },
  lastName: {
    label: `Prezime *`,
    error: {
      validate: `Prezime nije validno!`,
      required: `Prezime je neophodno!`,
    },
  },
  company: {
    label: `Kompanija *`,
    error: {
      validate: `Ime kompanije nije validno!`,
      required: `Ime kompanije je neophodno!`,
    },
  },
  companyEmail: {
    label: `Email Kompanije *`,
    error: {
      validate: `Email kompanije nije validan!`,
      required: `Email kompanije je neophodan!`,
    },
  },
  phone: {
    label: `Broj telefona`,
    error: {
      validate: `Broj telefona nije validan!`,
      required: `Broj telefona je neophodan!`,
    },
  },
  message: {
    label: `Poruka`,
    error: {
      validate: ``,
      required: ``,
    },
  },
  submitBtn: `Pošalji`,
};

const nameRegex = new RegExp('^([\\p{L}\\s]+)$', 'u');

const validationSchema = yup.object().shape({
  firstName: yup
    .string()
    .matches(nameRegex, {
      message: copy.firstName.error.validate,
      excludeEmptyString: true,
    })
    .required(copy.firstName.error.required),
  lastName: yup
    .string()
    .matches(nameRegex, {
      message: copy.lastName.error.validate,
      excludeEmptyString: true,
    })
    .required(copy.lastName.error.required),
  company: yup.string().required(copy.company.error.required),
  companyEmail: yup
    .string()
    .email(copy.companyEmail.error.validate)
    .required(copy.companyEmail.error.required),
});

type Props = {
  setSubmitted: Dispatch<SetStateAction<boolean>>;
};

export const PartnerForm: FC<Props> = ({ setSubmitted }) => {
  const methods = useForm<FormData>({
    mode: 'onBlur',
    resolver: yupResolver(validationSchema),
  });

  const { handleSubmit, reset } = methods;

  const [createPartnerForm] = useMutation(CREATE_PARTNER_FORM, {
    onCompleted() {
      reset();
      setSubmitted(true);
    },
  });

  const onSubmit = handleSubmit(data => {
    createPartnerForm({ variables: { input: { data } } });
  });

  return (
    <FormProvider {...methods}>
      <FormWrapper onSubmit={onSubmit} id="partner-form">
        <Container>
          <Box>
            <InputBox>
              <Input
                type="text"
                name="firstName"
                label="First Name"
                placeholder={copy.firstName.label}
                autoComplete="given-name"
                required
              />
            </InputBox>
            <InputBox>
              <Input
                type="text"
                name="lastName"
                label="Last Name"
                placeholder={copy.lastName.label}
                autoComplete="family-name"
                required
              />
            </InputBox>
            <InputBox>
              <Input
                type="text"
                name="company"
                label="Company"
                placeholder={copy.company.label}
                required
              />
            </InputBox>
            <InputBox>
              <Input
                type="text"
                name="companyEmail"
                label="Company Email"
                placeholder={copy.companyEmail.label}
                autoComplete="email"
                required
              />
            </InputBox>
            <InputBox>
              <Input
                type="text"
                name="phone"
                label="Phone Number"
                placeholder={copy.phone.label}
                autoComplete="tel"
              />
            </InputBox>
          </Box>
          <Box>
            <TextareaBox>
              <Textarea name="message" label={copy.message.label} rows={6} />
            </TextareaBox>
            <Submit type="submit">{copy.submitBtn}</Submit>
          </Box>
        </Container>
      </FormWrapper>
    </FormProvider>
  );
};
